import {
  FeatureImpl,
  IFeatureRepository,
} from "api/merchantRepository/features/FeatureRepository";
import {
  IRoamingPartnerRepository,
  RoamingPartnerImpl,
} from "api/repositories/roamingPartnerManagement/RoamingPartnerRepository";
import { ActionInjection } from "app/actions/di/ActionInjection";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";
import { FilterInjection } from "app/filters/di/FilterInjection";
import { AppStartUpInjection } from "app/startup/di/AppStartUpInjection";
import { SidebarMenuInjection } from "components/sidebar/di/SidebarMenuInjection";

export class AppBasedServiceInjection extends InjectionModule {
  private static readonly featureRepositoryToken = Symbol("IFeatureRepository");
  private static readonly roamingPartnerRepositoryToken = Symbol(
    "IRoamingPartnerRepository",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.featureRepositoryToken,
      useClass: FeatureImpl,
    },
    {
      scope: "otherRepo",
      token: this.roamingPartnerRepositoryToken,
      useClass: RoamingPartnerImpl,
    },
  ];

  static getFeatureRepo(): IFeatureRepository {
    return this.resolve(this.featureRepositoryToken);
  }

  static getRoamingPartnerRepo(): IRoamingPartnerRepository {
    return this.resolve(this.roamingPartnerRepositoryToken);
  }
}

export class AppCoreInjection {
  static initialize(): void {
    FilterInjection.initialize();
    ActionInjection.initialize();
    SidebarMenuInjection.initialize();
    AppBasedServiceInjection.initialize();
    AppStartUpInjection.initialize();
  }
}
